<template>
    <div id="calendar" class="calendar">
        <Confirmation v-if="showConfirmation" @resetBooking="
            showConfirmation = false;
        $store.commit('setSelectedBooking', '');
        selectedGuests = 0;
        currentGuestInfo = undefined;
        firstName = '';
        lastName = '';
        emailAddress = '';
        phoneNumber = '';
        notes = '';
        " :response="bookingResponse" />
        <div v-if="!showConfirmation" :class="{
            'date-not-chosen': $store.state.availableBookings.length === 0,
        }">
            <div>
                <h2>
                    <img src="@/assets/icons/date-selector.svg" alt="" />
                    <span>Select Date</span>
                </h2>
                <div class="holder">
                    <div class="ui">
                        <ArrowButton @click="changeMonth(-1)" />
                        <h3>{{ month }}</h3>
                        <ArrowButton next @click="changeMonth(1)" />
                    </div>
                    <div class="days">
                        <div>S</div>
                        <div>M</div>
                        <div>T</div>
                        <div>W</div>
                        <div>T</div>
                        <div>F</div>
                        <div>S</div>
                    </div>
                    <div class="month">
                        <Day v-for="day in content" :date="day.date" :day="day.day" :disabled="day.disabled" />
                    </div>
                </div>
            </div>
            <div v-show="$store.state.availableBookings.length !== 0" id="available-times">
                <transition name="fade" appear>
                    <div>
                        <h2>
                            <img src="@/assets/icons/clock-icon.svg" alt="" />
                            <span>Select Time</span>
                        </h2>
                        <AvailableTimes />
                    </div>
                </transition>
            </div>
            <div id="form" class="details" v-if="$store.state.selectedBooking !== ''" :class="{ 'show-errors': showErrors }">
                <transition name="fade" appear>
                    <div>
                        <h2>
                            <img src="@/assets/icons/person-icon.svg" alt="" />
                            <span>Enter Details</span>
                        </h2>
                        <div class="holder" style="min-width: 300px">
                            <table>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*First Name</span>
                                    </td>
                                    <td>
                                        <input :class="firstName !== '' ? 'has-value' : 'has-error'" type="text" name="firstname" id="firstname" v-model="firstName" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Last Name</span>
                                    </td>
                                    <td>
                                        <input :class="lastName !== '' ? 'has-value' : 'has-error'" type="text" name="lastname" id="lastname" v-model="lastName" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Email Address</span>
                                    </td>
                                    <td>
                                        <input :class="[
                                            emailAddress !== '' ? 'has-value' : '',
                                            emailAddress !== '' && isEmailValid ? '' : 'has-error',
                                        ]" type="email" name="email" id="email" v-model="emailAddress" />
                                    </td>
                                </tr>                                
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">*Phone</span>
                                    </td>
                                    <td>
                                        <input :class="[
                                            phoneNumber !== '' && phoneNumber.replace(/\D/g, '').length < 10
                                                ? 'has-error'
                                                : '',
                                        ]" type="tel" name="phonenumber" id="phonenumber" v-model="phoneNumber" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label-holder">
                                        <span class="label">Company</span>
                                    </td>
                                    <td>
                                        <input type="text" name="company" id="company" v-model="company" />
                                    </td>
                                </tr>                                
                                <tr style="display: none">
                                    <td class="label-holder">
                                        <span class="label">Zip Code</span>
                                    </td>
                                    <td>
                                        <input type="text" name="zip-code" id="zip-code" v-model="zipcode" maxlength="9" />
                                    </td>
                                </tr>
                                <tr style="display: none">
                                    <td class="label-holder"><span class="label">TM</span></td>
                                    <td>
                                        <input disabled="text" name="tm" id="tm" :value="$store.state.client.tmId" />
                                    </td>
                                </tr>
                                <tr class="guests">
                                    <td class="label-holder">
                                        <span class="label">Additional Guests<sub>(Up to 3)</sub></span>
                                    </td>
                                    <td>
                                        <div class="guest-options">
                                            <GuestButton v-for="guest in 4" :key="guest" :text="String(guest - 1)" :class="{ selected: selectedGuests === guest - 1 }" @click="selectedGuests = guest - 1" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <Button text="Add Guest Details" style="width: 100%" link="" @click="errorsInForm ? null : (showGuestsModal = true)" class="submit" :class="{ disabled: errorsInForm }" v-if="selectedGuests > 0" />
                            <Button v-else-if="!bookingProcessing" text="Book Now" style="width: 100%" link="" @click="submitAppointment" class="submit" :class="{ disabled: errorsInForm }" :disabled="bookingProcessing" />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
    <GuestModal v-if="showGuestsModal" :numGuests="selectedGuests" :currentGuestInfo="currentGuestInfo" @addGuest="selectedGuests = selectedGuests + 1" @removeGuest="selectedGuests = selectedGuests - 1" @close="showGuestsModal = false" @done="setGuests" @submitAppointment="submitAppointment" />
</template>

<script>
    import axios from "axios";
    import { format, add } from "date-fns";
    import ArrowButton from "@/components/ArrowButton";
    import GuestButton from "@/components/GuestButton";
    import Button from "@/components/Button";
    import AvailableTimes from "@/components/AvailableTimes";
    import GuestModal from "@/components/GuestModal";
    import Day from "@/components/Day";
    import Confirmation from "@/components/Confirmation";
    import validator from 'validator';
    export default {
        name: "Form",
        created() {
            this.now = new Date();
            this.getFirstMonthWithAppointments();
        },
        data() {
            return {
                month: "",
                content: "",
                now: undefined,
                selectedGuests: 0,
                showGuestsModal: false,
                currentGuestInfo: undefined,
                showConfirmation: false,
                testEmail: /^.+@.+\..+$/,
                showErrors: false,
                firstName: this.$store.state.client.first,
                lastName: this.$store.state.client.last,
                emailAddress: this.$store.state.client.email,
                phoneNumber: "",
                notes: "",
                company: "",
                zipcode: "",
                emailConsent: "",
                textConsent: "",
                bookingResponse: {},
                bookingProcessing: false,
                limitRecursion: 0,
            };
        },
        components: {
            Button,
            ArrowButton,
            Day,
            AvailableTimes,
            GuestButton,
            GuestModal,
            Confirmation,
        },
        computed: {
             isEmailValid() {
                return validator.isEmail(this.emailAddress)
            },
            isPhoneValid() {
                return validator.isMobilePhone(this.phoneNumber, 'en-US');
            },
            selectedSchedule() {
                return this.$store.state.selectedSchedule;
            },
            errorsInForm() {
                let errors = [];
                this.firstName !== "" ? "" : errors.push("first-name");
                this.lastName !== "" ? "" : errors.push("last-name");
                this.emailAddress !== "" && this.isEmailValid ? "" : errors.push("email-address");;
                this.isPhoneValid  ? "" : errors.push("phone-number");;
                return errors.length > 0;
            },
        },
        methods: {
            updateBookings() {
                this.$store.commit("setSelectedBooking", "");
                const params = new URLSearchParams();
                params.append("date", this.$store.state.selectedDate);
                params.append("schedule", this.$store.state.selectedSchedule);
                axios.post(`${this.$store.state.API}/Bookings.php`, params).then(this.onGetBookings);
            },
            onGetBookings(response) {
                if (response.data.status == "ok") {
                    this.$store.commit("setAvailableBookings", response.data["json-content"]);
                } else {
                    this.$store.commit("setSelectedDate", "");
                    alert("An error occurred getting the avilable times");
                }
            },
            submitAppointment() {
                if (this.bookingProcessing) {
                    console.log("booking processing");
                    return;
                }
                if (this.errorsInForm) {
                    this.showErrors = true;
                    return;
                }
                this.bookingProcessing = true;
                console.log("booking not processing");

                let combinedNotes = ``;
                this.showGuestsModal = false;
                const params = new URLSearchParams();
                params.append("appointment", this.$store.state.selectedBooking);
                params.append("first", this.firstName.trim());
                params.append("last", this.lastName.trim());
                params.append("email", this.emailAddress.trim());
                params.append("phone", this.phoneNumber.trim().replace(/\D/g, ""));
                params.append("notes", combinedNotes.trim());
                params.append("company", this.company.trim());
                params.append("guests", this.selectedGuests);

                if (this.selectedGuests > 0) {
                    this.currentGuestInfo.forEach((element, id) => {
                        params.append(`guestDetails[${id}][first]`, element.first);
                        params.append(`guestDetails[${id}][last]`, element.last);
                        params.append(`guestDetails[${id}][email]`, element.email);
                        //guestDetails[0][first]: gf
                        //guestDetails[0][last]: gl
                        //guestDetails[0][email]: richard@channel1media.com
                    });
                }

                const $this = this;

                params.append("display", "");
                params.append("address", "");
                params.append("purl", this.$route.params.purl);
                params.append("schedule", this.$store.state.selectedSchedule);
                axios
                    .post(`${this.$store.state.API}/Appointment.php`, params)
                    .then(this.onSubmitAppointment)
                    .finally(() => {
                        $this.bookingProcessing = false;
                    });
            },
            onSubmitAppointment(response) {
                if (response.data.status == "ok") {
                    this.showConfirmation = true;
                    this.bookingResponse = response.data;
                } else {
                    this.$store.commit("setAvailableBookings", []);
                    alert(response.data.message ?? "An unknown error occured.");
                    this.updateBookings();
                }
            },
            setGuests(guests) {
                this.selectedGuests = guests.length;
                this.currentGuestInfo = guests;
            },
            changeMonth(months) {
                this.now = add(this.now, { months: months });
                this.getMonth();
            },
            getMonth() {
                const params = new URLSearchParams();
                params.append("month", format(this.now, "M"));
                params.append("year", format(this.now, "yyyy"));
                params.append("schedule", this.$store.state.selectedSchedule);
                axios.post(`${this.$store.state.API}/Calendar.php`, params).then(this.onGetCalendar);
            },
            getFirstMonthWithAppointments() {
                const params = new URLSearchParams();
                params.append("month", format(this.now, "M"));
                params.append("year", format(this.now, "yyyy"));
                params.append("schedule", this.$store.state.selectedSchedule);
                this.limitRecursion++;
                if (this.limitRecursion === 6) {
                    alert('No available appointments within 6 months');
                    return;
                }
                axios.post(`${this.$store.state.API}/Calendar.php`, params).then(this.onGetCalendarWithAppointments);
            },
            onGetCalendarWithAppointments(response) {
                if (response.data.status == "ok") {
                    let hasAvailableAppointments = response.data["json-content"].some(item => item.disabled === false);
                    if (hasAvailableAppointments) {
                        this.month = response.data.month;
                        this.content = response.data["json-content"];
                    } else {
                        this.now = add(this.now, { months: 1 });
                        this.getFirstMonthWithAppointments();
                    }
                } else {
                    alert("An error occurred getting the month");
                }
            },
            onGetCalendar(response) {
                if (response.data.status == "ok") {
                    this.month = response.data.month;
                    this.content = response.data["json-content"];
                } else {
                    alert("An error occurred getting the month");
                }
            },
        },
        watch: {
            selectedSchedule(newValue) {
                this.content = "";
                this.getFirstMonthWithAppointments();
            },
        },
    };
</script>

<style lang="scss" scoped>

    .schedule-type {
        text-align: center;
        color: var(--white);
        font-weight: 600;
        margin-top: 75px;
        margin-bottom: 20px;
        font-size: 1.375rem;
        border: none;
    }

    p {
        text-align: center;
        color: var(--white);
        font-weight: 300;
        font-size: 1.125rem;
        max-width: 715px;
        margin: 0 auto;
        padding: 1rem;
    }

    .submit {
        position: relative;

        &:after {
            content: "fill in required fields to proceed";
            background: linear-gradient(180deg, #ab0808 0%, #f33 100%);
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: grid;
            place-items: center;
            font-weight: 600;
            color: var(--white);
            transition: all 0.2s ease-out;
        }

        &.disabled {
            cursor: default;
            opacity: 0.3;
            border: 1px solid var(--accent);
            pointer-events: all;
            overflow: hidden;

            &:hover {
                opacity: 1;

                &:after {
                    opacity: 1;
                }
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0 10px;
        table-layout: fixed;
    }

    table {
        color: var(--white);
        text-align: left;
        width: 100%;

        td {
            white-space: nowrap;
        }

        span {
            color: var(--black);
            font-family: "proxima-nova", sans-serif;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0.28px;
            text-transform: uppercase;
        }

        .label-holder {
            width: 170px;

            sub {
                display: block;
            }
        }

        input {
            padding: 10px 15px;
            width: 100%;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 1);
            border: none;
            color: var(--black);
            
            font-family: "proxima-nova", sans-serif;
            font-size: 16px;
        }

        .guests td {
            padding: 20px 0;
        }

        .guest-options {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 20px;

            button {
                height: 40px;
                width: 40px;
            }
        }
    }

    .invitation {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.6;
        font-style: italic;
        margin-top: 25px;
    }

    .details {
        flex-grow: 1;

        &.show-errors .has-error {
            border: 1px solid var(--red);
        }
    }

    .holder {
        padding: 20px 30px;
    }

    h2 {
        background: var(--green);
        color: var(--white);
        font-family: "proxima-nova", sans-serif;
        font-size: 20px;
        font-weight: 800;
        text-transform: uppercase;
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 16px 22px;
        margin-top: 0;
    }

    h3 {
        color: var(--green);
        text-align: center;
        font-family: "proxima-nova", sans-serif;
        font-size: 22px;
        font-weight: 800;
        letter-spacing: 0.44px;
        text-transform: uppercase;
    }

    .ui {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    #calendar {
        background: url("~@/assets/images/booking.jpg");
        background-size: cover;
        background-position: center;

        >div {
            overflow: hidden;
            max-width: 500px;
            margin: 25px auto;

            >div {
                margin-top: 75px;
                background: #FFFFFF;

                &:not(:nth-child(2)) {
                    background: #F6F6F6;
                }

            }

            @media (min-width: 1110px) {
                display: flex;

                max-width: 1110px;
                margin: 75px auto;
                margin-top: 0;

                &.date-not-chosen {
                    display: block;
                    width: 450px;
                }

                &.confirmation {
                    margin-top: 75px;
                }

                >div {
                    position: relative;

                    &:after {
                        content: "";
                        height: 6px;
                        background: var(--accent);
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 0;
                        transition: width 0.2s ease-in-out;
                    }
                }
            }
        }
    }

    .days,
    .month {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        place-items: center;
        gap: 10px;
    }

    .month {
        grid-auto-rows: 40px;
    }

    .days {
        border-radius: 500px;
        background: var(--green);
        box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.25);

        color: var(--white);
        padding: 10px 0;
        text-align: center;
        font-family: "proxima-nova", sans-serif;
        font-size: 16px;
        font-weight: 800;
        letter-spacing: 0.32px;
        text-transform: uppercase;
    }

    .month {
        padding: 15px 0;
    }
</style>
